<script>
import * as Dimensions from '@/lib/dimensions';
import * as Units from '@/lib/units';
import In from "@/components/atoms/In";
import Check from "@/components/atoms/Check";
import * as Id from '@/lib/id';

export default {
  name: 'PartRow',
  components: {In, Check},
  props: ["ledgerPart", "index", "number", "showSelect", "showRemove", "highlight"],
  data(){
    return {
      customName: '',
      editCustomName: false,
      editCustomQuantity: false,
      highlighting: false 
    }
  },
  computed: {
    part(){
      return this.$store.get("parts/partById", this.ledgerPart.id);
    },
    useMetric(){
      return this.$store.get('useMetric')
    },
    width(){
      return (this.ledgerPart.customWidth || (this.part.categories && this.part.categories.includes("PanelPlateAndMesh"))) ? this.metersToInches(this.ledgerPart.width) : null;
    },
    height(){
      return this.ledgerPart.customHeight ? this.metersToInches(this.ledgerPart.height) : null;
    },
    length(){
      return this.ledgerPart.customLength || (this.part.categories && (this.part.categories.includes("T-SlottedProfiles") || this.part.categories.includes("PanelPlateAndMesh"))) ? this.metersToInches(this.ledgerPart.length) : null;
    },
    size(){
      return {
        ...(this.length ? {Length: this.length} : {}),
        ...(this.width ? {Width: this.width} : {}),
        ...(this.height ? {Height: this.height} : {}),
      }
    },
    vendor(){
      return this.$store.get('parts/getVendorForPart', this.part);
    },
    partPriceLabel(){
      return Units.getPriceLabel(this.part.price);
    },
    price(){
      return 0;
    }, 
    name(){
      if(this.part.sub_name){
        return this.part.name+' '+this.part.sub_name
      }else{
        return this.part.name
      }
    },
    image_url(){
      return Id.getPartImageURL(this.part.id)
    },
    requiredMachiningByType(){
      if(this.ledgerPart.requiredMachining){
        const a = this.ledgerPart.requiredMachining.reduce((acc, requiredMachining) => {
          let key = requiredMachining.machining+"_"+requiredMachining.type;
          if(acc[key]){
            acc[key].push(requiredMachining) 
          }else{
            acc[key] = [requiredMachining]
          }
          return acc;
        }, {})
        return a;
      }else{
        return {}
      }
    },
    quantity(){
      return (this.ledgerPart.customQuantity !== undefined && this.ledgerPart.customQuantity !== "") ? this.ledgerPart.customQuantity : this.ledgerPart.quantity
    },
    highlightedParts(){
      return this.$store.get('parts/highlightedParts')
    }
  },
  watch: {
    highlightedParts(){
      if(!this.highlightedParts){
        this.highlighting = false;
      }
    }
  },
  methods: {
    metersToInches(val){
      return Units.metersToInches(val, this.useMetric);
    },
    track(link){
      this.mixpanel.track('Vendor Link', {
        link
      });
    },
    getNumber(value){
      return Units.getNumber(value)
    },
    getMachineTitle(title){
      switch (title) {
        case 'M8': 
          return 'M8'
        case 'M12': 
          return 'M12'
        case 'I516': 
          return '5/16"'
        case 'I12': 
          return '1/2"'
        case 'M20': 
          return 'M20'
        case 'I813': 
          return '.813"'
        case 'I295': 
          return '.295"'
        default:
          return title;
      }
    },
    roundDollars(val){
      return Units.roundDollars(val);
    },
    highlightParts(){
      this.highlighting = !this.highlighting;
      if(this.highlighting){
        this.$store.commit('parts/highlightedParts', true);
        this.$emit("highlightparts", this.ledgerPart)
      }else{
        this.$emit("unhighlightparts", this.ledgerPart)
      }
    },
  }
}
</script>


<template>
  <div>
    <div class="item-row" :class="{'highlight': highlight}">
      <div class="eye" v-if="highlight" @click="highlightParts">
        <span class="fa fa-map-marker-alt" :class="{'highlighting': highlighting}"></span>
      </div>
      <div class="check-container" v-if="showSelect">
        <Check :value="!ledgerPart.dontAddToOrder" @input="($event) => $set(ledgerPart, 'dontAddToOrder', !$event)" v-if="ledgerPart.materialPrice"></Check>
        <div v-else class="check-placeholder">
          -
        </div>
      </div>
      <div class="index">
        <span v-if="number !== undefined">
          {{number + 1}}.
        </span>
      </div>
      <div class="row part-row">
        <div class="item-col" v-if="ledgerPart && part">
          <div class="image-col" @click="$router.push({ path: '/part/'+ledgerPart.id })">
            <img :src="image_url" />
          </div>
          <div class="name-col">
            <div class="name" @click="$router.push({ path: '/part/'+ledgerPart.id })">
              <template v-if="customName == null || customName == ''">
                {{name ? name : part.id}}
              </template>
              <template v-else>
                {{customName}}
              </template>
            </div>
            <div class="sizes" v-if="Object.keys(size).length > 0">
              <span class="size" v-for="(key, index) in Object.keys(size)" :key="index">
                <span class="name">{{key}}:</span>
                <span class="value" v-html="size[key]"></span>
              </span>
            </div>
            <!-- <div class="sizes" >
              <span v-for="(tap, index) in taps" :key="index" class="size">
                <span class="name" v-if="tap.includes(' x ')">Required end taps:</span>
                <span class="name" v-else>Required end tap:</span>
                <span class="value">{{tap}}</span>
              </span>
            </div> -->
            <div class="required-machining" v-if="ledgerPart.requiredMachining && ledgerPart.requiredMachining.length > 0">
              <div v-for="(key, index) in Object.keys(requiredMachiningByType)" class="req" :key="index">
                <template v-if="key.split('_')[0] == 'DRILLHOLE'">
                  <div class="title">
                    {{getMachineTitle(key.split('_')[1])}} Hole (Length x Width) - NOT INCLUDED
                  </div>
                  <div class="hole-container">
                    <div v-for="(requiredMachining, i) in requiredMachiningByType[key]" :key="i" class="hole">
                      <div class="hole-row">
                        <span class="fa fa-circle"></span><span v-html="metersToInches(requiredMachining.position.z)"></span><span class="divider">x</span><span v-html="metersToInches(requiredMachining.position.x)"></span>
                      </div>
                    </div>    
                  </div>
                </template>
                <template v-if="key.split('_')[0] == 'COUNTERBORE'">
                  <div class="title">
                    <img class="machine-icon" :src="'./icons/counterbore.svg'"/> {{getMachineTitle(key.split('_')[1])}} Counterbore
                  </div>
                  <div class="side-container">
                    <div v-for="(side, i) in ['Front', 'Back']" :key="i" class="side" v-if="requiredMachiningByType[key].some(requiredMachining => requiredMachining.side == side)">
                      <div v-if="part.profile.includes('Single')" class="profile-container single">
                        <img class="profile" :src="'./icons/Single.svg'"/>
                        <div v-for="(requiredMachining, j) in requiredMachiningByType[key]" :key="j" v-if="requiredMachining.side == side">
                          <span v-if="requiredMachining.location == 'U'" class="mark u"></span>
                          <span v-if="requiredMachining.location == 'D'" class="mark d"></span>
                          <span v-if="requiredMachining.location == 'L'" :class="side == 'Front' ? 'mark r' : 'mark l'"></span>
                          <span v-if="requiredMachining.location == 'R'" :class="side == 'Front' ? 'mark l' : 'mark r'"></span>
                        </div>
                      </div>
                      <div v-else-if="part.profile.includes('Double')" class="profile-container double">
                        <img class="profile" :src="'./icons/DoubleVert.svg'"/>
                        <div v-for="(requiredMachining, j) in requiredMachiningByType[key]" :key="j" v-if="requiredMachining.side == side">
                          <span v-if="requiredMachining.location == 'DL'" :class="side == 'Front' ? 'mark dr' : 'mark dl'"></span>
                          <span v-if="requiredMachining.location == 'DR'" :class="side == 'Front' ? 'mark dl' : 'mark dr'"></span>
                          <span v-if="requiredMachining.location == 'UL'" :class="side == 'Front' ? 'mark ur' : 'mark ul'"></span>
                          <span v-if="requiredMachining.location == 'UR'" :class="side == 'Front' ? 'mark ul' : 'mark ur'"></span>
                          <span v-if="requiredMachining.location == 'UU'" class="mark uu"></span>
                          <span v-if="requiredMachining.location == 'DD'" class="mark dd"></span>
                        </div>
                      </div>
                      <div v-else-if="part.profile.includes('Quad')" class="profile-container quad">
                        <img class="profile" :src="'./icons/Quad.svg'"/>
                        <div v-for="(requiredMachining, j) in requiredMachiningByType[key]" :key="j" v-if="requiredMachining.side == side">
                          <span v-if="requiredMachining.location == 'DLD'" :class="side == 'Front' ? 'mark drd' : 'mark dld'"></span>
                          <span v-if="requiredMachining.location == 'DLL'" :class="side == 'Front' ? 'mark drr' : 'mark dll'"></span>
                          <span v-if="requiredMachining.location == 'DRD'" :class="side == 'Front' ? 'mark dld' : 'mark drd'"></span>
                          <span v-if="requiredMachining.location == 'DRR'" :class="side == 'Front' ? 'mark dll' : 'mark drr'"></span>
                          <span v-if="requiredMachining.location == 'ULL'" :class="side == 'Front' ? 'mark urr' : 'mark ull'"></span>
                          <span v-if="requiredMachining.location == 'ULU'" :class="side == 'Front' ? 'mark uru' : 'mark ulu'"></span>
                          <span v-if="requiredMachining.location == 'URR'" :class="side == 'Front' ? 'mark ull' : 'mark urr'"></span>
                          <span v-if="requiredMachining.location == 'URU'" :class="side == 'Front' ? 'mark ulu' : 'mark uru'"></span>
                        </div>
                      </div>
                      <div v-else-if="part.profile.includes('Multi')" class="profile-container multi">
                        <img class="profile" :src="'./icons/MultiVert.svg'"/>
                        <div v-for="(requiredMachining, j) in requiredMachiningByType[key]" :key="j" v-if="requiredMachining.side == side">
                          <span v-if="requiredMachining.location == 'DL'" :class="side == 'Front' ? 'mark dr' : 'mark dl'"></span>
                          <span v-if="requiredMachining.location == 'DR'" :class="side == 'Front' ? 'mark dl' : 'mark dr'"></span>
                          <span v-if="requiredMachining.location == 'UL'" :class="side == 'Front' ? 'mark ur' : 'mark ul'"></span>
                          <span v-if="requiredMachining.location == 'UR'" :class="side == 'Front' ? 'mark ul' : 'mark ur'"></span>
                          <span v-if="requiredMachining.location == 'ML'" :class="side == 'Front' ? 'mark mr' : 'mark ml'"></span>
                          <span v-if="requiredMachining.location == 'MR'" :class="side == 'Front' ? 'mark ml' : 'mark mr'"></span>
                          <span v-if="requiredMachining.location == 'UU'" class="mark uu"></span>
                          <span v-if="requiredMachining.location == 'DD'" class="mark dd"></span>
                        </div>
                      </div>
                      <div class="side-title">
                        {{side}}
                      </div>
                    </div>
                  </div>
                </template>
                <template v-if="key.split('_')[0] == 'ACCESSHOLE'">
                  <div class="title">
                    <img class="machine-icon access" :src="'./icons/accesshole2.svg'"/> {{getMachineTitle(key.split('_')[1])}} Access Holes - NOT INCLUDED
                  </div>
                  <div class="side-group">
                    <div class="side-container" v-for="(requiredMachining, j) in requiredMachiningByType[key]" :key="j">
                      <div class="side">
                        <div v-if="part.profile.includes('Single')" class="profile-container single">
                          <img class="profile" :src="'./icons/Single.svg'"/>
                          <span v-if="requiredMachining.slot == 'FU-BU'" class="mark u"></span>
                          <span v-if="requiredMachining.slot == 'FD-BD'" class="mark d"></span>
                          <span v-if="requiredMachining.slot == 'FL-BL'" class="mark r"></span>
                          <span v-if="requiredMachining.slot == 'FR-BR'" class="mark l"></span>
                        </div>
                        <div v-else-if="part.profile.includes('Double')" class="profile-container double">
                          <img class="profile" :src="'./icons/DoubleVert.svg'"/>
                          <span v-if="requiredMachining.slot == 'FU-BU'" class="mark uu"></span>
                          <span v-if="requiredMachining.slot == 'FD-BD'" class="mark dd"></span>
                          <span v-if="requiredMachining.slot == 'FLU-BLU'" class="mark ur"></span>
                          <span v-if="requiredMachining.slot == 'FLD-BLD'" class="mark dr"></span>
                          <span v-if="requiredMachining.slot == 'FRU-BRU'" class="mark ul"></span>
                          <span v-if="requiredMachining.slot == 'FRD-BRD'" class="mark dl"></span>
                        </div>
                        <div v-else-if="part.profile.includes('Quad')" class="profile-container quad">
                          <img class="profile" :src="'./icons/Quad.svg'"/>
                          <span v-if="requiredMachining.slot == 'FUR-BUR'" class="ulu"></span>
                          <span v-if="requiredMachining.slot == 'FUL-BUL'" class="uru"></span>
                          <span v-if="requiredMachining.slot == 'FDR-BDR'" class="dld"></span>
                          <span v-if="requiredMachining.slot == 'FDL-BDL'" class="drd"></span>
                          <span v-if="requiredMachining.slot == 'FLU-BLU'" class="urr"></span>
                          <span v-if="requiredMachining.slot == 'FLD-BLD'" class="drr"></span>
                          <span v-if="requiredMachining.slot == 'FRU-BRU'" class="ull"></span>
                          <span v-if="requiredMachining.slot == 'FRD-BRD'" class="dll"></span>
                        </div>
                        <div v-else-if="part.profile.includes('Multi')" class="profile-container multi">
                          <img class="profile" :src="'./icons/MultiVert.svg'"/>
                          <span v-if="requiredMachining.slot == 'FU-BU'" class="mark uu"></span>
                          <span v-if="requiredMachining.slot == 'FD-BD'" class="mark dd"></span>
                          <span v-if="requiredMachining.slot == 'FLU-BLU'" class="mark ur"></span>
                          <span v-if="requiredMachining.slot == 'FLD-BLD'" class="mark dr"></span>
                          <span v-if="requiredMachining.slot == 'FRU-BRU'" class="mark ul"></span>
                          <span v-if="requiredMachining.slot == 'FRD-BRD'" class="mark dl"></span>
                          <span v-if="requiredMachining.slot == 'FRM-BRM'" class="mark ml"></span>
                          <span v-if="requiredMachining.slot == 'FLM-BLM'" class="mark mr"></span>
                        </div>
                        <div class="side-title">
                          <span v-html="metersToInches(requiredMachining.distance)"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-if="key.split('_')[0] == 'ENDTAP'">
                  <div class="title">
                    <img class="machine-icon" :src="'./icons/endtap.svg'"/> {{getMachineTitle(key.split('_')[1])}} End Tap
                  </div>
                  <div class="side-container">
                    <div v-for="(side, i) in ['Front', 'Back']" :key="i" class="side" v-if="requiredMachiningByType[key].some(requiredMachining => requiredMachining.side == side && part.profile)">
                      <div v-if="part.profile.includes('Single')" class="profile-container single">
                        <img class="profile" :src="'./icons/Single.svg'"/>
                        <div v-for="(requiredMachining, j) in requiredMachiningByType[key]" :key="j" v-if="requiredMachining.side == side">
                          <span class="mark c"></span>
                        </div>
                      </div>
                      <div v-else-if="part.profile.includes('Double')" class="profile-container double">
                        <img class="profile" :src="'./icons/DoubleVert.svg'"/>
                        <div v-for="(requiredMachining, j) in requiredMachiningByType[key]" :key="j" v-if="requiredMachining.side == side">
                          <span v-if="requiredMachining.location.includes('U')" class="mark tap_u"></span>
                          <span v-if="requiredMachining.location.includes('D')" class="mark tap_d"></span>
                        </div>
                      </div>
                      <div v-else-if="part.profile.includes('Quad')" class="profile-container quad">
                        <img class="profile" :src="'./icons/Quad.svg'"/>
                        <div v-for="(requiredMachining, j) in requiredMachiningByType[key]" :key="j" v-if="requiredMachining.side == side">
                          <span v-if="requiredMachining.location.includes('DL')" :class="side == 'Front' ? 'mark dr' : 'mark dl'"></span>
                          <span v-if="requiredMachining.location.includes('DR')" :class="side == 'Front' ? 'mark dl' : 'mark dr'"></span>
                          <span v-if="requiredMachining.location.includes('UL')" :class="side == 'Front' ? 'mark ur' : 'mark ul'"></span>
                          <span v-if="requiredMachining.location.includes('UR')" :class="side == 'Front' ? 'mark ul' : 'mark ur'"></span>
                        </div>
                      </div>
                      <div v-else-if="part.profile.includes('Multi')" class="profile-container multi">
                        <img class="profile" :src="'./icons/MultiVert.svg'"/>
                        <div v-for="(requiredMachining, j) in requiredMachiningByType[key]" :key="j" v-if="requiredMachining.side == side">
                          <span v-if="requiredMachining.location.includes('U')" class="mark tap_u"></span>
                          <span v-if="requiredMachining.location.includes('M')" class="mark tap_m"></span>
                          <span v-if="requiredMachining.location.includes('D')" class="mark tap_d"></span>
                        </div>
                      </div>
                      <div class="side-title">
                        {{side}}
                      </div>
                    </div>
                  </div>
                </template>
                <!-- <span class="name" v-if="tap.includes(' x ')">Required end taps:</span>
                <span class="name" v-else>Required end tap:</span> -->
              </div>
            </div>
            <!-- <div class="distributors">
              <template v-if="vendor">
                <a v-for="(link, index) in vendor.links" :key="index" :href="link" target="_blank" @click="track(link)">{{vendor.name}}</a>
              </template> 
            </div> -->
          </div>
        </div>
        <div v-else class="item-col">
          Missing: {{ledgerPart.id}}
        </div>
        <div class="quantity-col" v-if="ledgerPart.materialPrice">
          <in v-model="ledgerPart.customQuantity" :placeholder="ledgerPart.quantity" :autofocus="editCustomQuantity" type="number" @blur="($event) => $set(ledgerPart, 'customQuantity', $event)"></in>
        </div>
        <div class="quantity-col" v-else>
          <div class="fixed-quantity">
            {{ledgerPart.quantity}}
          </div>
        </div>
        <!-- <div v-else @click="() => editCustomQuantity = true" class="quantity-col">
          {{ledgerPart.quantity}}
        </div> -->
        <div class="price-col">
          <div class="price-row">
            <template v-if="ledgerPart.machiningPrice || ledgerPart.materialPrice">
              ${{roundDollars(ledgerPart.machiningPrice + ledgerPart.materialPrice)}}
            </template>
            <template v-else>
              -
            </template>
          </div>
        </div>
        <div class="total-price-col">
          <template v-if="part && (ledgerPart.machiningPrice || ledgerPart.materialPrice)">
            ${{roundDollars((ledgerPart.machiningPrice + ledgerPart.materialPrice) * quantity)}}
          </template>
          <template v-else>
            -
          </template>
        </div>
        <div class="remove-col" v-if="showRemove">
          <div class="remove fa fa-times" @click="$emit('remove')"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  @import "~@/styles/constants";
  .item-row{
    .eye{
      opacity: 1;
      font-size: 1.5rem;
      opacity: 1;
      color: $w_1;
      border-radius: 4px;
      width: 46px;
      height: 46px;
      display: flex;
      align-items: center;
      justify-content: center;
      &:hover, &.hover{
        cursor: pointer;
        background-color: rgba(255,255,255,0.1);
      }
      .highlighting{
        color: $p;
      }
    }
  }
  .check-container{
    margin-right: 0.5rem;
    .check-placeholder{
      width: 46px;
      height: 46px;
      font-size: 1.25rem;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .part-row{
    // border-bottom: 1px solid $w_1;
    // padding-bottom: 2rem;
    .item-col{
      .input{
        input{
          height: 2rem;
          padding: 0rem 0.75rem;
        }
      }
    }
    .name-col{
      min-height: 28px;
      flex: 1;
      .name{
        font-size: 1.25rem;
      }
      .input{
        margin: -0.357rem -0.875rem;
        input{
          font-size: 1.125rem;
          width: 100%;
        }
      }
      .fa-pen{
        font-size: 0.8rem; 
        color: $w_1;
      }
    }
    .image-col, .name{
      &:hover, &.hover{
        cursor: pointer;
      }
    }
    .sizes{
      padding-top: 0.5rem;
      .size{
        margin-right: 1rem;;
        // font-size: 1.125rem;
        font-weight: 500;
        // color: $y;
        .name{
          color: $w_1;
          font-size: 1.125rem;
          margin-right: 0.5rem;
        }
        .value{
          font-size: 1.25rem;
          .unit{
            // font-size: 0.875rem;
          }
        }
      }
    }
    .required-machining{
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      .req{
        padding-top: 0.75rem;
        margin-right: 2rem;
        .title{
          display: flex;
          align-items: center;
          padding-bottom: 0.5rem;
          font-weight: 500;
          color: $p_1;
          .machine-icon{
            width: 1rem;
            margin-right: 0.5rem;
          }
          .fa-circle{
            font-size: 1rem;
            margin-right: 0.5rem;
          }
        }
        .side-group{
          display: flex;
          align-items: center;
        }
        .hole-container{
          .hole{
            .hole-row{
              display: flex;
              align-items: center;
            }
            .fa-circle{
              margin-right: 0.5rem;
              font-size: 0.5rem;
            }
            .divider{
              margin: 0rem 0.5rem;
            }
          }
        }
        .side-container{
          display: flex;
          align-items: center;
          .side{
            display: flex;
            flex-direction: column;
            align-items: center;
            .side-title{
              margin-top: 0.25rem;
              font-size: 0.85rem;
              color: $w;
            }
            .profile-container{
              margin: 1rem 1.25rem;
              position: relative;
              display: flex;
              align-items: center;
              justify-content: center;
              &.tight{
                margin: 0.5rem 1rem;
              }
              &.single{
                width: 2rem;
                height: 2rem;
                .mark{
                  &.c{
                  top: 50%;
                  left: 50%;
                  }
                  &.u{
                    top: calc(0% - 0.5rem);
                    left: 50%;
                  }
                  &.d{
                    top: calc(100% + 0.5rem);
                    left: 50%;
                  }
                  &.l{
                    top: 50%;
                    left: calc(0% - 0.5rem);
                  }
                  &.r{
                    top: 50%;
                    left: calc(100% + 0.5rem);
                  }
                }
              }
              &.double{
                width: 2rem;
                height: 4rem;
                .mark{
                  &.dl{
                    top: 75%;
                    left: calc(0% - 0.5rem);
                  }
                  &.dr{
                    top: 75%;
                    left: calc(100% + 0.5rem);
                  }
                  &.ul{
                    top: 25%;
                    left: calc(0% - 0.5rem);
                  }
                  &.ur{
                    top: 25%;
                    left: calc(100% + 0.5rem);
                  }
                  &.uu{
                    top: calc(0% - 0.5rem);
                    left: 50%;
                  }
                  &.dd{
                    top: calc(100% + 0.5rem);
                    left: 50%;
                  }
                }
              }
              &.quad{
                width: 4rem;
                height: 4rem;
                .mark{
                  &.dl{
                    top: 75%;
                    left: 25%;
                  }
                  &.dr{
                    top: 75%;
                    left: 75%;
                  }
                  &.ul{
                    top: 25%;
                    left: 25%;
                  }
                  &.ur{
                    top: 25%;
                    left: 75%;
                  } 
                  &.dld{
                    top: calc(100% + 0.5rem);
                    left: 25%;
                  }
                  &.dll{
                    top: 75%;
                    left: calc(0% - 0.5rem);
                  }
                  &.drd{
                    top: calc(100% + 0.5rem);
                    left: 75%;
                  }
                  &.drr{
                    top: 75%;
                    left: calc(100% + 0.5rem);
                  }
                  &.ull{
                    top: 25%;
                    left: calc(0% - 0.5rem);
                  }
                  &.ulu{
                    top: calc(0% - 0.5rem);
                    left: 25%;
                  }
                  &.urr{
                    top: 25%;
                    left: calc(100% + 0.5rem);
                  }
                  &.uru{
                    top: calc(0% - 0.5rem);
                    left: 75%;
                  }
                }
              }
              &.multi{
                width: 2rem;
                height: 6rem;
                .mark{
                  &.dl{
                    top: 80%;
                    left: calc(0% - 0.5rem);
                  }
                  &.dr{
                    top: 80%;
                    left: calc(100% + 0.5rem);
                  }
                  &.ul{
                    top: 20%;
                    left: calc(0% - 0.5rem);
                  }
                  &.ur{
                    top: 20%;
                    left: calc(100% + 0.5rem);
                  }
                  &.mr{
                    top: 50%;
                    left: calc(100% + 0.5rem);
                  }
                  &.ml{
                    top: 50%;
                    left: calc(0% - 0.5rem);
                  }
                  &.uu{
                    top: calc(0% - 0.5rem);
                    left: 50%;
                  }
                  &.dd{
                    top: calc(100% + 0.5rem);
                    left: 50%;
                  }
                }
              }
              .profile{
                width: 100%;
                height: 100%;
              }
              .mark{
                width: 0.5rem;
                height: 0.5rem;
                border-radius: 50%;
                background-color: $p;
                position: absolute;
                transform: translate(-50%,-50%);
                border: 2px solid $black_1;
                
                
                &.tap_u{
                  top: 25%;
                  left: 50%;
                }
                &.tap_m{
                  top: 50%;
                  left: 50%;
                }
                &.tap_d{
                  top: 75%;
                  left: 50%;
                }
              }
            }
          }
        }
      }
    }
    .taps{
      padding-top: 0.5rem;
      .tap{
        margin-right: 1rem;;
        font-size: 1.125rem;
        font-weight: 500;
        // color: $y;
        .name{
          margin-right: 0.5rem;
        }
        .value{
        }
      }
    }
    .quantity-col{
      &:hover, .hover{
        cursor: pointer;
      }
      .input{
        margin: -0.357rem 0rem;
        input{
          width: 6rem;
          height: 2rem;
          padding: 0rem 0rem 0rem 0.75rem;
        }
      }
      .fixed-quantity{
        font-size: 1.125rem;
      }
    }
    .price-col{
      .price-row{
        display: flex;
        align-items: center;
        justify-content: flex-end;
        width: 100%;
        .surcharge{
          color: $w_1;
          font-size: 0.825rem;
        }
        .input{
          margin: -0.357rem 0rem;
          input{
            width: 6rem;
            height: 2rem;
            padding: 0rem 0rem 0rem 0.75rem;
          }
        }
        .fa-pen{
          opacity: 0;
          font-size: 0.875rem;
          color: $w_1;
          margin-left: 0.25rem;
          margin-right: -1.125rem;
        }
        &:hover, .hover{
          cursor: pointer;
          .fa-pen{
            opacity: 1;
          }
        }
      }
    }
    .remove{
      padding: 1rem;
      border-radius: 0.5rem;
      margin-right: -2rem;
      margin-left: 1rem;
      color: $w_1;
      &:hover, .hover{
        background-color: $black_3;
        cursor: pointer;
      }
    }
  }
</style>